import { z } from "zod";

/**
 * Change Password Form Validation Schema
 * ------------------------------------------------------------
 * Validates the fields required to change a password
 * Fields:
 * - oldPassword: required, must not be empty
 * - newPassword: required, 8-50 characters
 * - confirmPassword: required, must match newPassword
 */
export const changePasswordSchema = z
  .object({
    oldPassword: z.string().min(1, "Old password is required"), // Old password cannot be empty
    newPassword: z
      .string()
      .min(8, { message: "Password must be at least 8 characters long." })
      .max(50, { message: "Password must not exceed 50 characters." })
      .refine((val) => !/\s/.test(val), {
        message: "Password must not contain spaces.",
      })
      .refine((val) => /[a-z]/.test(val), {
        message: "Password must contain at least one lowercase letter.",
      })
      .refine((val) => /[A-Z]/.test(val), {
        message: "Password must contain at least one uppercase letter.",
      })
      .refine((val) => /\d/.test(val), {
        message: "Password must contain at least one number.",
      }),
    confirmPassword: z.string().min(1, "Confirm your new password"), // Must not be empty
  })
  // Optional: Uncomment to enforce newPassword and confirmPassword match
  .refine((data) => data.newPassword === data.confirmPassword, {
    path: ["confirmPassword"],
    message: "Passwords do not match",
  });
